import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import type { StandardDetailBackSource } from '../standardDetailBackNavigation'

type StandardDetailBreadcrumbProps = {
  backSource: StandardDetailBackSource
  backTo: string
  currentLabel: string
}

export function StandardDetailBreadcrumb({
  backSource,
  backTo,
  currentLabel,
}: StandardDetailBreadcrumbProps) {
  const { t } = useTranslation('standardsLibrary')

  const parentLabel =
    backSource === 'machinery-directive-standards'
      ? t('detail.breadcrumbComplianceStudio')
      : t('title')

  return (
    <Breadcrumb aria-label={t('detail.breadcrumbNavLabel')}>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={backTo}>{parentLabel}</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage className='max-w-[min(100%,28rem)] truncate'>
            {currentLabel}
          </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}
